<div class="form-row">
  <label class="editCustomFieldDescriptionLabel modal__body-title">
    {{ 'custom_field_description' | ppTranslate }}
  </label>
  <div class="addCF__description" [class.addCF__description--focused]="focused">
    <textarea
      id="customFieldDescriptionInput"
      class="addCF__description-input"
      name="label"
      [ngModel]="ppDescription()"
      (ngModelChange)="ppDescriptionChange.emit($event)"
      [placeholder]="ppPlaceholder() | ppTranslate"
      (keydown.enter)="blurInput($event)"
      (focus)="onInputFocus()"
      (focusout)="onInputFocusLost()"
      rows="1"
      autocomplete="off"
      type="text"
      (input)="onInput($event)"
      #input
    ></textarea>
  </div>
</div>
